// react-router v7 owns navigation through context — no external `history` instance.
// Keep a small shim so legacy `history.push("/foo")` call sites (e.g. App.tsx's redirect
// restore on first load) keep working via window.location until those call sites are
// rewritten to useNavigate.
const history = {
    push: (to) => {
        window.location.assign(to);
    },
    replace: (to) => {
        window.location.replace(to);
    },
    listen: () => () => {},
    location: window.location,
};

export default history;
